/* Product page tabs: on desktop the tab blocks (About this artwork, Specifications, Delivery, Care instructions, Ask a question)
   move out of the buying column into ONE full-width row of headings under the artwork and buying column; the chosen tab's text shows
   underneath. On a phone they stay where the theme put them: one drawer under another, tap to open.
   Shared by the print page (template product.print / default) and the Large Canvas page. Presentation only. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function init() {
    var blocks = $('[data-product-blocks]'), left = $('.product-single__sticky');
    if (!blocks || !left) return;
    var pw = left.closest('.page-width'); if (!pw) return;
    var tabs = $$('.product-block--tab', blocks);
    if (tabs.length < 2) return;
    var homes = tabs.map(function (blk) {                       // remember where each tab lives so a phone can put it back
      var c = document.createComment('sg-tab'); blk.parentNode.insertBefore(c, blk); return c;
    });
    var box = null, host = null, bar = null, current = 0, wide = window.matchMedia('(min-width: 769px)');

    function show(n) {
      current = n;
      $$('.sg-pr-tabbtn', bar).forEach(function (x, j) { x.setAttribute('aria-selected', j === n ? 'true' : 'false'); });
      tabs.forEach(function (blk, j) { blk.classList.toggle('sg-pr-tab-on', j === n); });
    }
    function build() {
      box = document.createElement('div'); box.className = 'page-width sg-pr-tabs-wide';
      host = document.createElement('div'); host.className = 'sg-pr-tabs sg-pr-tabs--row'; box.appendChild(host);
      pw.parentNode.insertBefore(box, pw.nextSibling);
      bar = document.createElement('div'); bar.className = 'sg-pr-tabbar'; bar.setAttribute('role', 'tablist');
      tabs.forEach(function (blk, i) {
        var trig = $('.collapsible-trigger-btn', blk); if (!trig) return;
        var b = document.createElement('button'); b.type = 'button'; b.className = 'sg-pr-tabbtn'; b.setAttribute('role', 'tab');
        b.textContent = trig.textContent.replace(/\s+/g, ' ').trim();
        b.addEventListener('click', function () { show(i); });
        bar.appendChild(b);
      });
      host.appendChild(bar);
    }
    function toRow() {
      if (!box) build();
      tabs.forEach(function (blk) { host.appendChild(blk); });
      box.hidden = false;
      document.documentElement.classList.add('sg-tabs-row');
      show(current);
    }
    function toStack() {
      tabs.forEach(function (blk, i) {
        blk.classList.remove('sg-pr-tab-on');
        homes[i].parentNode.insertBefore(blk, homes[i].nextSibling);
      });
      if (box) box.hidden = true;
      document.documentElement.classList.remove('sg-tabs-row');
    }
    function apply() { if (wide.matches) toRow(); else toStack(); }
    if (wide.addEventListener) wide.addEventListener('change', apply); else wide.addListener(apply);
    apply();
    // artwork height budget: the fixed header's height, so the CSS can fit the artwork into the window under it
    var setHdr = function () {
      var h = $('#SiteHeader'), hh = h ? h.offsetHeight : 150, st = document.documentElement.style;
      st.setProperty('--sg-hdr', hh + 'px'); st.setProperty('--sg-pr-sticky-top', (hh + 20) + 'px');   // where the stuck artwork sits: just under the header
    };
    setHdr(); window.addEventListener('resize', setHdr); window.addEventListener('load', setHdr);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
